$(function(){
    async function updateCartpage() {
  const res = await fetch("/?section_id=c-cart-page");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox1 = html.querySelector(".u_cart_page_wrapper").innerHTML;
  document.querySelector(".u_cart_page_wrapper").innerHTML = newBox1;
}
    function CartCount() {
        $.getJSON('/cart.js', function(cart){ 
          //       console.log(cart);
          var result = cart.item_count;
          console.log('cart count',result);
          if(result > 0){
            $('.u_cart_counter').text(result);
          }
        });
      }
  $(function(){
  CartCount()    
  })
$(document).on('click','.product-form__submit,.ag_fc_product_button_c',function(){
   setTimeout(function(){
      $(document).scrollTop(0)
  CartCount()  
   },1000)
 
})

   $('.u_cart_page_cont').on('click','.u_minus',function(){
    let input =$(this).parent().find('.u_number');
    let count =parseInt(input.val()) -1;
    let counter = count <1 ?1:count;
    input.val(counter);
    input.attr('value',counter);
      let var_line =parseInt($(this).closest('.u_cart_page_items_body_item').attr('var_line'));
      let ths = $(this)
 $.ajax({
  url:'/cart/change.js',
  type:'post',
  dataType:'json',
  data:{
          quantity: count, 
          line: var_line
  },
      beforeSend: function(){
        ths.addClass("u_custom_disabled");
        $('.u_cart_page_overlay').show()
      },
      success:function(__cart){
        console.log('ajax request', __cart);
        updateCartpage()
        CartCount()
      },
    complete: function(){
        setTimeout(function(){
          ths.removeClass("u_custom_disabled");
                  $('.u_cart_page_overlay').hide();
                  renderRelated();
        }, 800);
    }
 })
  })
    $('.u_cart_page_cont').on('click','.u_plus',function(){
    let input =$(this).parent().find('.u_number');
    let input_val =parseInt(input.val());
    let pro_qty =parseInt($(this).parents('.u_quantity').find('.u_pro_qty').val());
  let var_policy =$(this).parents('.u_quantity').find('.u_atc_var_plicy').val();
      let var_line =parseInt($(this).closest('.u_cart_page_items_body_item').attr('var_line'));
    console.log('product qty',pro_qty);
    if(var_policy == 'deny' && input_val >= pro_qty )
    {
      console.log('zero--');
            alertify.error('This item has zero quantity left');
    }
    else{
                let count =parseInt(input.val()) +1;
    input.val(count);
     input.attr('value',count);
       let ths = $(this)
 $.ajax({
  url:'/cart/change.js',
  type:'post',
  dataType:'json',
  data:{
          quantity: count, 
          line: var_line
  },
      beforeSend: function(){
        ths.addClass("u_custom_disabled");
         $('.u_cart_page_overlay').show()
      },
      success:function(__cart){
        console.log('ajax request', __cart);
        updateCartpage()
        CartCount()
      },
    complete: function(){
        setTimeout(function(){
          ths.removeClass("u_custom_disabled");
           $('.u_cart_page_overlay').hide();
           renderRelated();
        }, 800);
    }
 })
    }
  })
        $('.u_cart_page_cont').on("click",".u_cart_page_remove",function() {
         let var_line =parseInt($(this).closest('.u_cart_page_items_body_item').attr('var_line'));
      let ths = $(this)
 $.ajax({
  url:'/cart/change.js',
  type:'post',
  dataType:'json',
  data:{
          quantity: 0, 
          line: var_line
  },
      beforeSend: function(){
        ths.addClass("u_custom_disabled");
         $('.u_cart_page_overlay').show()
      },
      success:function(__cart){
        console.log('ajax request', __cart);
        updateCartpage()
        CartCount()
      },
    complete: function(){
        setTimeout(function(){
          ths.removeClass("u_custom_disabled");
           $('.u_cart_page_overlay').hide();
           renderRelated();
        }, 800);
    }
 })
        })
  $(document).on('click','.u_cart_page_shipping_val,.u_cart_shipping_remove',function(){
     $('.u_cart_page_shipping_val').toggle()  
     $('.u_cart_shipping_remove').toggle()  
  $('.u_shipping_estimator').toggle()  
  })
   $(document).on('click','.u_cart_page_coupon_val,.u_cart_coupon_remove',function(){
     $('.u_cart_page_coupon_val').toggle()  
     $('.u_cart_coupon_remove').toggle()  
  $('.u_cart_coupon_wrapper').toggle()  
  })
       $(document).on('keyup', '.u_coupon_inp', function(){ 
        $('.u_coupon_btn').attr('href', '/checkout/?discount='+ $(this).val());
      });
})